<div class="flx-modal" role="dialog" aria-modal="true">
    <!-- header -->
    <div class="flx-modal__header w-f3">
        <div class="with-desc">
            <h2>Technician Color Codes</h2>
            <div class="sub">Assign colors to each technician</div>
        </div>
        <button type="button" class="icon-btn" [pTooltip]="translate?.general.buttons.close.singular" (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>

    <form>
        <div class="flx-modal__body mp-body p-0">
            <!-- Search bar -->
            <div class="color-code-search">
                <span class="p-input-icon-left w-100">
                    <i class="fa-regular fa-magnifying-glass"></i>
                    <input type="text" pInputText autocomplete="off"
                        [placeholder]="translate?.general.buttons.search.singular"
                        [(ngModel)]="searchValue"
                        (ngModelChange)="applySearch()"
                        name="colorCodeSearch" />
                </span>
            </div>
            <div class="color-code-table-scroll">
                <table class="color-code-table">
                    <thead>
                        <tr>
                            <th>Username</th>
                            <th>Color Code</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let user of filteredUserList">
                            <td class="color-code-table__username">
                                <div class="color-code-table__user">
                                    <div class="color-code-table__avatar">{{ user.initials }}</div>
                                    <span class="color-code-table__name" [title]="user.name">{{ user.name }}</span>
                                </div>
                            </td>
                            <td class="color-code-table__color">
                                <div class="color-code-table__color-wrap">
                                    <app-color-code-picker
                                        [(color)]="user.color"
                                        variant="inline"
                                        [saveLabel]="translate?.general.buttons.save.singular || 'Save'"
                                        (colorChange)="onColorSelected(user, $event)">
                                    </app-color-code-picker>
                                </div>
                            </td>
                            <td class="color-code-table__actions">
                                <a
                                    [href]="'/dashboard/setup/allUser/view?id=' + user.id + '&edit=false'"
                                    target="_blank"
                                    class="color-code-table__profile-link"
                                    [pTooltip]="'View Profile'"
                                    tooltipPosition="left">
                                    <i class="fa-regular fa-arrow-up-right-from-square"></i>
                                </a>
                            </td>
                        </tr>

                        <tr *ngIf="!filteredUserList?.length">
                            <td colspan="3" class="color-code-table__empty">
                                <i class="fa-regular fa-user-slash"></i>
                                <span>No users found</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </form>

    <!-- footer -->
    <div class="flx-modal__footer">
        <button type="button" class="custella-btn-white" (click)="modalRef.hide()">
            {{ translate?.general.buttons.cancel.singular }}
        </button>
    </div>
</div>
